import React from 'react';
import PropTypes from 'prop-types';
import { LegendWrapper, ColorBlock, Header } from './styled';
import { Cross, Tick, NoAttempt, Clock } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';
import {
  statusLabels, ASSIGNED, INCORRECT, CORRECT, UNATTEMPTED,
  UNAVAILABLE, SCHEDULED_ASSIGN
} from '../status-cell/utils';

const Legend = (props) => {
  const { i18n, isVisible } = props;

  if (!isVisible) return null;

  return (
    <LegendWrapper>
      <Header>
        {i18n.t`Key/Filter`}
        <div className="sub-heading">{i18n.t`Student Progress`}</div>
      </Header>
      <span className="item">
        <ColorBlock color="#dae7d3" data-name="assigned" />
        <label htmlFor="assigned">{statusLabels[ASSIGNED].toString()}</label>
      </span>
      <span className="item">
        <ColorBlock color="#dae7d3" data-name="scheduled">
          <span className="icon">
            <SvgIcon icon={Clock} fill="grey" />
          </span>
        </ColorBlock>
        <label htmlFor="scheduled">{statusLabels[SCHEDULED_ASSIGN].toString()}</label>
      </span>
      <span className="item">
        <ColorBlock color="#900012" data-name="incorrect">
          <span className="icon">
            <SvgIcon icon={Cross} />
          </span>
        </ColorBlock>
        <label htmlFor="incorrect">{statusLabels[INCORRECT].toString()}</label>
      </span>
      <span className="item">
        <ColorBlock color="#008902" data-name="correct">
          <span className="icon">
            <SvgIcon icon={Tick} />
          </span>
        </ColorBlock>
        <label htmlFor="correct">{statusLabels[CORRECT].toString()}</label>
      </span>
      <span className="item">
        <ColorBlock color="#94B4C9" data-name="expired">
          <span className="icon">
            <SvgIcon icon={NoAttempt} />
          </span>
        </ColorBlock>
        <label htmlFor="expired">{statusLabels[UNATTEMPTED].toString()}</label>
      </span>
      <span className="item">
        <ColorBlock color="#c2c2c2" data-name="unavailable" />
        <label htmlFor="expired">{statusLabels[UNAVAILABLE].toString()}</label>
      </span>
    </LegendWrapper>
  );
};

Legend.propTypes = {
  i18n: PropTypes.object,
  isVisible: PropTypes.bool
};

Legend.defaultProps = {
  isVisible: false
};

export default Legend;
